import React from 'react';
import {Card, CardContent, CardHeader} from '@material-ui/core';

export default (): React.ReactElement => <Card>
    <CardHeader title="Welcome to the administration" />
    {process.env.NODE_ENV !== 'production' && <CardContent>
        Branch name: {process.env.REACT_APP_BRANCH_NAME}
    </CardContent>}
</Card>;
